// extracted by mini-css-extract-plugin
export default {"shell":"AdminLayout_shell__GjcWf","main":"AdminLayout_main__AHbAC","content":"AdminLayout_content__S0kKK"};